import { joinPath } from '@eventbrite/path-utils';
import { replace } from 'react-router-redux';
import { Dispatch } from 'redux';
import { CannedQuestionName } from '../api/models/survey';
import { transformWaitlistEntryData } from '../api/transformations/order';
import { addToWaitlist as addToWaitlistApi } from '../api/waitlist';
import { BASE_URL, WAITLIST_CONFIRMATION_PATH } from '../constants';
import { CheckoutState } from '../state';
import { getInitialPath } from '../utils/routes';
import { generateGuestToken } from './guest';
import { saveWaitlistEntryAction } from './order';

export const MARK_WAITLIST_FULL = 'markWaitlistFull';

const _markWaitlistFull = () => ({
    type: MARK_WAITLIST_FULL,
});

const _handleOnAddToWaitlistError = (
    dispatch: Dispatch<CheckoutState>,
    error: Error & { extraData?: { parsedError?: { error: string } } },
) => {
    if (
        error &&
        error.extraData &&
        error.extraData.parsedError &&
        error.extraData.parsedError.error === 'WAITLIST_FULL'
    ) {
        dispatch(_markWaitlistFull());
    }

    throw error;
};

export const goToPageBeforeWaitlistPage =
    () =>
    (dispatch: Dispatch<CheckoutState>, getState: () => CheckoutState) => {
        const state = getState();

        dispatch(replace(joinPath(getInitialPath(state))));
    };

export const addToWaitlist =
    (buyerData: {
        [CannedQuestionName.firstName]: string;
        [CannedQuestionName.lastName]: string;
        [CannedQuestionName.email]: string;
        [CannedQuestionName.homePhone]?: string;
    }) =>
    async (
        dispatch: Dispatch<CheckoutState>,
        getState: () => CheckoutState,
    ) => {
        const state = getState();
        const formattedBuyerData = transformWaitlistEntryData(buyerData);

        try {
            if (!state.event || !('id' in state.event)) {
                throw new Error(
                    '[EB-133142] Tried to add buyer to waitlist with an `undefined` event',
                );
            }

            await generateGuestToken(dispatch, state.event.id);
            await addToWaitlistApi(state.event.id, formattedBuyerData);
            await dispatch(saveWaitlistEntryAction(formattedBuyerData));

            dispatch(replace(joinPath(BASE_URL, WAITLIST_CONFIRMATION_PATH)));
        } catch (e) {
            _handleOnAddToWaitlistError(dispatch, e as Error);
        }
    };
